import SageScreen from "kit/SageScreen";
import React from "react";
import { useSelector } from "react-redux";
import fileIdSelector from "selectors/fileIdSelector";
import CreateJobBody from "./createJob/CreateJobBody";

const CreateJob: React.FC = () => {
    const fileId = useSelector(fileIdSelector);

    return (
        <SageScreen>
            <div className="row align-items-center">
                <div className="col">
                    <h1>Create Job</h1>
                    {fileId ? (
                        <CreateJobBody fileId={fileId} />
                    ) : (
                        <p>File not found</p>
                    )}
                </div>
            </div>
        </SageScreen>
    );
};

export default CreateJob;
